export const datapointStart = {
    assetsDatapointStart: "asset.",
    fundsDatapointStart: "fund.",
    fundsInvestorDatapointStart: "fund.investor",
    instrumentDatapointStart: "instrument.",
    managerDatapointStart: "manager.",
    portfolioDatapointStart: "portfolio."
};
